import { render, staticRenderFns } from "./TcTitle.vue?vue&type=template&id=7e0a46a9&"
import script from "./TcTitle.vue?vue&type=script&lang=js&"
export * from "./TcTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0a46a9')) {
      api.createRecord('7e0a46a9', component.options)
    } else {
      api.reload('7e0a46a9', component.options)
    }
    module.hot.accept("./TcTitle.vue?vue&type=template&id=7e0a46a9&", function () {
      api.rerender('7e0a46a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcTitle.vue"
export default component.exports